import 'common/rollbar';
// Bootstrap

import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
// Components

import './components/navigation';
import './components/vero-tracking';
import './components/scroll-to-target';
import './components/forms';
import './components/tabs';
import './components/fixed-cta';
import './components/packages-filter';
import './components/offers-portal-state-select';
import './components/print';
import './components/tns';
import { reactOnCms } from 'common/js/react_on_cms';
import GiftCards from 'tenants/brilliant-travels/gift_cards';
import Carousel from './components/carousel';
import FormCaptcha from './components/form-captcha';

reactOnCms.register({
  GiftCards,
});

document.addEventListener('DOMContentLoaded', () => {
  new FormCaptcha();
  document.querySelectorAll('.carousel').forEach((element) => {
    new Carousel(element).start();
  });
});
